<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card" v-bind:class="[selectDisable ? '' : 'disabled']">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">{{ action }} Report</h1>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <b-field label="Customer">
              <b-select
                name="customer"
                :disabled="isAdd"
                v-model="editObjectName.customer"
                expanded
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in customers"
                  :value="option.id"
                  :key="index"
                  selected
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
            <b-field label="Country">
              <b-select
                name="country"
                :disabled="isAdd"
                v-model="editObjectName.country_id"
                v-on:input="filterScheme"
                expanded
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in countries"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
            <b-field label="Scheme">
              <b-select
                name="scheme"
                :disabled="isAdd"
                v-model="editObjectName.scheme_id"
                v-on:input="filterStream"
                expanded
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in schemes"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
            <b-field label="Stream">
              <b-select
                name="stream"
                :disabled="isAdd"
                v-model="editObjectName.stream_id"
                v-on:input="filterReports"
                expanded
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in containers"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
            <b-field label="Short report name">
              <b-select
                name="scheme"
                :disabled="isAdd"
                v-model="editObjectName.report"
                expanded
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in reports"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.report_type }}
                </option>
              </b-select>
            </b-field>
            <b-field label="Valid from">
              <b-datepicker
                name="valid_from"
                :disabled="disable"
                v-model="editObjectName.valid_from_date"
                icon="calendar-today"
                trap-focus
                :date-formatter="dateFormatter"
              >
              </b-datepicker>
            </b-field>
            <b-field label="Valid to">
              <b-datepicker
                name="valid_to"
                :disabled="disable"
                v-model="valid_to_date"
                icon="calendar-today"
                trap-focus
                :date-formatter="dateFormatter"
              >
                <b-button type="is-danger" @click="valid_to_date = null">
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </b-button>
              </b-datepicker>
            </b-field>
            <b-field label="Additional Info">
              <b-input
                name="additional_info"
                :disabled="disable"
                v-model="editObjectName.additional_info"
              />
            </b-field>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot" v-if="!disable">
        <b-button slot="right" type="is-primary" @click="saveReport">
          Save
        </b-button>
        <b-button slot="right" type="is-danger" @click="cancel">
          Cancel
        </b-button>
      </footer>
      <footer class="modal-card-foot" v-if="disable">
        <b-button
          v-if="disable && isAdmin() && this.action !== 'View'"
          slot="right"
          type="is-danger"
          @click="removeReport"
        >
          Delete
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { Permission } from "../../services/Permissions";
import CountryDataService from "../../services/CountryDataService";
import ContainerDataService from "../../services/ContainerDataService";
import SchemeDataService from "../../services/SchemeDataService";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
import ReportingTrackerDataService from "../../services/ReportingTrackerDataService";
// @group Customers
export default {
  name: "CustomerReportAddView",
  props: {
    action: {
      type: String,
      default: "Inserts"
    },
    isAdd: {
      type: Boolean,
      default: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    editObjectName: {
      type: Object,
      default: () => {
        return {
          id: "",
          customer: "",
          country: "",
          scheme: "",
          stream: "",
          report: "",
          valid_from: "",
          valid_to: "",
          frequency: "",
          additional_info: ""
        };
      }
    },

    customerId: {
      type: Number,
      default: -1
    }
  },

  data() {
    return {
      containerDataService: new ContainerDataService(),
      countryDataService: new CountryDataService(),
      schemeDataService: new SchemeDataService(),
      customerDataService: new CustomerProfileDataService(),
      reportingTrackerService: new ReportingTrackerDataService(),
      isModalActive: false,
      customers: [],
      schemes: [],
      countries: [],
      containers: [],
      reports: [],
      selectDisable: true,
      valid_to_date: this.editObjectName?.valid_to_date
    };
  },
  mounted() {
    this.fetchCountries();
    this.fetchSchemes();
    this.fetchContainers();
    this.fetchCustomerList();
    this.fetchReportingTrackerData();
    this.disableSelectProperty();
  },
  computed: {
    disable() {
      if (this.action == "Edit") {
        return false;
      } else if (this.action == "View") {
        return true;
      } else if (this.action == "Delete") {
        return true;
      }
      return false;
    },
    countryList() {
      return this.$store.state.countryList;
    },
    schemeList() {
      return this.$store.state.schemeList;
    },
    containerList() {
      return this.$store.state.containerList;
    },
    ...mapGetters(["userId", "userName", "userHasPermission"])
  },
  methods: {
    disableSelectProperty() {
      if (this.isAction == "Edit" || this.action == "Delete") {
        this.selectDisable = false;
      }
    },
    filterReports(streamId) {
      this.editObjectName.report = null;
      this.reportingTrackerService
        .getReportBySchemeStream(
          this.editObjectName.scheme_id,
          streamId,
          0,
          true
        )
        .subscribe(
          response => {
            this.reports = response;
          },
          e => {
            console.log(e);
          }
        );
    },
    dateFormatter(dt) {
      if (dt != null) {
        return dt.toLocaleDateString("fr-CA");
      }
      return dt;
    },
    isAdmin() {
      if (this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL)) {
        return true;
      }
      return true;
    },
    hasPermission() {
      if (
        this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL) ||
        this.userHasPermission(Permission.CUSTOMER_PROFILE_CHANGE_CAM)
      ) {
        return true;
      }
      return false;
    },
    prepareMasterData(data) {
      const resultDict = {};
      for (const idx in data) {
        const dataDict = data[idx];
        resultDict[dataDict["id"]] = dataDict["name"];
      }
      return resultDict;
    },
    fetchReportingTrackerData() {
      this.isLoading = true;
      this.reportingTrackerService.getAllReports().subscribe(
        response => {
          this.reports = response;
        },
        e => {
          console.log(e);
        }
      );
    },
    fetchCountries() {
      if (this.countryList.length > 0) {
        this.countries = this.countryList;
        this.countryMap = this.prepareMasterData(this.countries);
      } else {
        this.countryDataService.getAll().subscribe(
          response => {
            this.countries = response;
            this.$store.dispatch("setCountryList", response);
            this.countryMap = this.prepareMasterData(this.countries);
          },
          e => {
            console.log(e);
          }
        );
      }
    },
    fetchSchemes() {
      if (this.schemeList.length > 0) {
        this.schemes = this.schemeList;
        this.schemeMap = this.prepareMasterData(this.schemes);
      } else {
        this.schemeDataService.getAll().subscribe(
          response => {
            this.schemes = response;
            this.$store.dispatch("setSchemeList", response);
            this.schemeMap = this.prepareMasterData(this.schemes);
          },
          e => {
            console.log(e);
          }
        );
      }
    },
    fetchContainers() {
      if (this.containerList.length > 0) {
        this.containers = this.containerList;
        this.containers = this.containers.filter(e => e.name !== "General");
        this.containerMap = this.prepareMasterData(this.containers);
      } else {
        this.containerDataService.getAll().subscribe(
          response => {
            this.containers = response;
            this.$store.dispatch("setContainerList", response);
            this.containers = this.containers.filter(e => e.name !== "General");
            this.containerMap = this.prepareMasterData(this.containers);
          },
          e => {
            console.log(e);
          }
        );
      }
    },
    fetchCustomerList() {
      this.customerDataService.getCustomerList(this.customerId, true).subscribe(
        customerProfiles => {
          this.customers = customerProfiles;
        },
        e => {
          console.log(e);
        }
      );
    },
    filterScheme(countryId) {
      this.schemeDataService.getByCountry(countryId).subscribe(
        response => {
          this.schemes = response;
        },
        e => {
          console.log(e);
        }
      );
    },
    filterStream(schemeId) {
      this.editObjectName.stream_id = null;
      this.schemeDataService.get(schemeId).subscribe(
        response => {
          this.containers = response["container"];
          this.containers = this.containers.filter(e => e.name !== "General");
        },
        e => {
          console.log(e);
        }
      );
    },
    cancel() {
      this.$emit("cancel");
    },
    saveReport() {
      this.editObjectName.valid_to_date = this.valid_to_date;
      if (this.action == "Add") {
        this.addReport();
      } else if (this.action == "Edit") {
        this.updateReport();
      }
    },
    addReport() {
      this.customerDataService
        .createCustomerReport(this.editObjectName)
        .subscribe(response => {
          this.$emit("confirm", response);
          this.$buefy.dialog.alert({
            title: "Success",
            message: "Report Added!"
          });
        }, this.handleApiError);
    },
    updateReport() {
      this.customerDataService
        .updateCustomerReport(this.editObjectName)
        .subscribe(response => {
          this.$emit("confirm", response);
          this.$buefy.dialog.alert({
            title: "Success",
            message: "Report Updated!"
          });
        }, this.handleApiError);
    },
    removeReport() {
      this.customerDataService
        .removeCustomerReport(this.editObjectName.id)
        .subscribe(response => {
          this.$emit("confirm", response);
          this.$buefy.dialog.alert({
            title: "Success",
            message: "Report Removed!"
          });
        }, this.handleApiError);
    },
    handleApiError(reason) {
      let errorMessage = reason.response.data["detail"];
      if (errorMessage == null || errorMessage == undefined) {
        errorMessage = reason.response.data["name"];
        if (errorMessage == null || errorMessage == undefined) {
          errorMessage =
            "Invalid input: Country, Scheme, Stream & Report are mandatory fields";
        } else {
          errorMessage = reason.response.data["name"][0];
        }
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
    }
  },

  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    },
    editObjectName() {
      this.valid_to_date = this.editObjectName?.valid_to_date;
    }
  }
};
</script>
